import { useMemo, useState } from 'react';
import { Panel } from '../../../components/panels/Panel';
import { VERALLIA_DASHBOARD_MOCK_DETECTIONS } from '../../../data/verallia-dashboard-mock-data';
import {
  filterVeralliaDashboardDetections,
  getVeralliaDashboardDefaultFilters,
} from '../../../services/dashboard/verallia-dashboard-service';
import { VeralliaDashboardFilters } from './components/VeralliaDashboardFilters';
import { VeralliaDashboardDetectionsTable } from './components/VeralliaDashboardDetectionsTable';

export const VeralliaDashboardDetections = () => {
  const [filters, setFilters] = useState(() =>
    getVeralliaDashboardDefaultFilters(VERALLIA_DASHBOARD_MOCK_DETECTIONS)
  );

  const [page, setPage] = useState(1);

  const filteredDetections = useMemo(() => {
    return filterVeralliaDashboardDetections(
      VERALLIA_DASHBOARD_MOCK_DETECTIONS,
      filters,
    );
  }, [filters]);

  const handleFiltersChange = (nextFilters) => {
    setFilters(nextFilters);
    setPage(1);
  };

  return (
    <Panel title="DETECTED PALLETS">
      <div className="mx-auto flex w-11/12 flex-col gap-4 py-6">
        <VeralliaDashboardFilters
          detections={VERALLIA_DASHBOARD_MOCK_DETECTIONS}
          value={filters}
          onChange={handleFiltersChange}
        />

        <div className="text-xs font-semibold uppercase tracking-wider text-perception-gray-600">
          {filteredDetections.length} detections matched
        </div>

        <VeralliaDashboardDetectionsTable
          detections={filteredDetections}
          page={page}
          onPageChange={setPage}
        />
      </div>
    </Panel>
  );
};